import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

const ListMenu = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  width: 298px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
`;

const ListMenuItem = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  cursor: pointer;
`;

const MenuItemContent = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  align-self: stretch;
  background: ${(props) => (props.active ? "rgb(97, 98, 197)" : "transparent")};
  box-sizing: border-box;
  padding: 12px 16px;
  flex-shrink: 0;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${(props) =>
      props.active ? "rgb(97, 98, 197)" : "rgba(97, 98, 197, 0.1)"};
  }
`;

const MenuItemText = styled.span`
  color: ${(props) => (props.active ? "white" : "rgb(33, 37, 67)")};
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
  flex: 1;
`;

const NotificationBadge = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgb(239, 68, 68);
  flex-shrink: 0;
  box-shadow: 0 0 0 2px ${(props) => (props.active ? "rgb(97, 98, 197)" : "transparent")};
`;

const SideText = styled.span`
  color: "#212543";
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  margin: 0;
  padding: 0;
  margin-top: 16px;
  margin-bottom: 4px
`;

const SidebarNav = () => {

  const location = useLocation()
  const navigate = useNavigate()
  const activeItem = location.pathname.split("/")[1]
  const [referralCount, setReferralCount] = useState(0)

  // Fetch pending referral count on component mount
  useEffect(() => {
    const fetchReferralCount = async () => {
      try {
        const params = new URLSearchParams();
        params.append("page", "1");
        params.append("limit", "1");
        params.append("approval_status", "pending");

        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/referrals?${params.toString()}`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              "x-user-role": "admin",
            },
          }
        );

        if (res.ok) {
          const json = await res.json();
          setReferralCount(json.total || 0);
        }
      } catch (error) {
        console.error("Failed to fetch referral count:", error);
      }
    };

    fetchReferralCount();

    // Refresh count every 30 seconds
    const interval = setInterval(fetchReferralCount, 30000);

    return () => clearInterval(interval);
  }, []);

  const onItemClick = (route) => {
    navigate("/" + route)
  }

  const menuItems = [
    { id: "adminpendingreferrals", label: "Referral Requests" },
    { id: "adminreferralsone", label: "Referrals" },
    { id: "adminwaitlist", label: "Waitlist" },
    { id: "adminmembersone", label: "Members" },
    { id: "payout-requests", label: "Payout requests" },
    { id: "charity-payouts", label: "Charity Payouts" },
    { id: "adminpayments", label: "Payments" },
    { id: "adminqueriesone", label: "Dispute" },
    { id: "charities", label: "Charities" },
    { id: "reffered-friends", label: "Referred Members" },
    { id: "refer-reward", label: "Refer a Friend Rewards" },
  ];

  const vendorItems = [
    { id: "adminvendorsone", label: "All Vendors" },
    { id: "adminrecommendationsone", label: "Recommendations" },
    { id: "adminfeaturedvendorsone", label: "Featured Vendors" },
    { id: "adminindustrysectorsone", label: "Categories - Industry Sector" },
    { id: "adminprofileupdaterequests", label: "Profile update requests" },
  ];

  const contentItems = [
    { id: "adminvendorshomeone", label: "Vendors on Home" },
    { id: "adminfaqone", label: "FAQ's" },
  ];

  const adminItems = [
    { id: "adminaccountsone", label: "Admin - accounts" },
  ];

  return (
    <ListMenu>
      {menuItems.map((item) => (
        <ListMenuItem key={item.id} onClick={() => onItemClick(item.id)}>
          <MenuItemContent active={activeItem === item.id}>
            <MenuItemText active={activeItem === item.id}>
              {item.label}
            </MenuItemText>
            {item.id === "adminpendingreferrals" && referralCount > 0 && (
              <NotificationBadge active={activeItem === item.id} />
            )}
          </MenuItemContent>
        </ListMenuItem>
      ))}
      <SideText>Vendors</SideText>
      {vendorItems.map((item) => (
        <ListMenuItem key={item.id} onClick={() => onItemClick(item.id)}>
          <MenuItemContent active={activeItem === item.id}>
            <MenuItemText active={activeItem === item.id}>
              {item.label}
            </MenuItemText>
          </MenuItemContent>
        </ListMenuItem>
      ))}
      <SideText>Website Content</SideText>
      {contentItems.map((item) => (
        <ListMenuItem key={item.id} onClick={() => onItemClick(item.id)}>
          <MenuItemContent active={activeItem === item.id}>
            <MenuItemText active={activeItem === item.id}>
              {item.label}
            </MenuItemText>
          </MenuItemContent>
        </ListMenuItem>
      ))}
      <SideText>Admin</SideText>
      {adminItems.map((item) => (
        <ListMenuItem key={item.id} onClick={() => onItemClick(item.id)}>
          <MenuItemContent active={activeItem === item.id}>
            <MenuItemText active={activeItem === item.id}>
              {item.label}
            </MenuItemText>
          </MenuItemContent>
        </ListMenuItem>
      ))}
    </ListMenu>
  );
};

export default SidebarNav;
